import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TimelineUpdate from 'pages/campaign/components/CampaignUpdates/components/TimelineUpdate/TimelineUpdate';
import './_style.scss';
const CampaignUpdateTimeline = ({ updates }) => {
    const Constructor = updates.map((update) => _jsx(TimelineUpdate, { update: update.node }, update.node.id));
    return (_jsxs("div", { className: "timeline", "data-testid": "timeline", children: [_jsx("div", { className: "timeline__start" }), _jsx("div", { className: "timeline__list", children: Constructor }), _jsx("div", { className: "timeline__end" })] }));
};
export default CampaignUpdateTimeline;
